import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import styled from '@emotion/styled';
import { StyledIconButtonTsoPq } from '@pages/HarmonicBackgroundLevel/harmonicBackgroundLevelStyles';

export const StyledParametersWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4,
});

export const StyledLineWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

export const StyledDeleteButton = styled(StyledIconButtonTsoPq)({
  alignSelf: 'flex-end',
  height: '2.25rem',
  width: '2.25rem',
});
